export enum Roles {
  DataCoordinator = 'Data Coordinator',
  FedDataAnalyst = 'Fed Data Analyst',
  GrantAdmin = 'Grant Admin',
  GrantUser = 'Grant User',
  ProjectOfficer = 'Project Officer',
  SystemSupportStaff = 'System Support Staff',
  SubrecipientUser = 'Subrecipient User',
}
